import React, { useEffect } from "react";
import { loadingDone, loadingStart } from "@/lib/loadingBar";

// Spinner mientras llega una pantalla (Suspense) o la sesión.
const PageLoader = () => {
  // Mientras se muestra, también avanza la barra de progreso superior.
  useEffect(() => {
    loadingStart();
    return loadingDone;
  }, []);
  return (
    <div className="flex h-[80vh] w-full items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-green-600"></div>
    </div>
  );
};

export default PageLoader;
